import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import SuperAdmin from './pages/SuperAdmin';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Profile from './pages/Profile';
import Courts from './pages/Courts';
import BusinessProfile from './pages/BusinessProfile';

// Al inicio del archivo, antes del return
const savedTheme = localStorage.getItem('winal_theme');
if (savedTheme === 'light') document.body.classList.add('light');

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/canchas" element={<PrivateRoute><Courts /></PrivateRoute>} />
          <Route path="/negocio-perfil" element={<PrivateRoute><BusinessProfile /></PrivateRoute>} />
          <Route path="/superadmin" element={<PrivateRoute><SuperAdmin /></PrivateRoute>} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          {/* Cualquier ruta vieja del CRM (users, billing, workspaces, etc.)
              redirige al dashboard en lugar de romper */}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;